<template>
  <div class="d-flex flex-row">
    <h4 class="header align-self-center">
      {{ $t('workpackagePage.wpTypeLabel') }}
    </h4>
    <v-select
      class="wp-select ml-2"
      hide-details
      required
      :disabled="selectionDisabled"
      :model-value="type"
      :items="types"
      :rules="rules"
      :placeholder="$t('workpackagePage.scope.filterByCategoryLabel')"
      :menu-props="{ bottom: true, offsetY: true }"
      variant="underlined"
      @update:model-value="onChange('type', $event)"
    />
  </div>
</template>

<script>
import { usePermission } from '@/composables/use-permission';

export default {
  props: {
    types: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: () => '',
    },
    rules: {
      type: Array,
      required: false,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {
    const { canChangeWorkpackageType } = usePermission();
    return { canChangeWorkpackageType };
  },
  computed: {
    selectionDisabled() {
      return this.disabled || !this.canChangeWorkpackageType;
    },
  },
  methods: {
    onChange(field, value) {
      this.$emit('update', { field, value });
    },
  },
};
</script>

<style lang="scss" scoped>
.wp-select {
  :deep() {
    .v-field__input {
      padding: 0;
      font-weight: 600;
    }

    .v-field__append-inner {
      padding-top: 0;
    }
  }
}
</style>
